import { useState } from 'react';

export default () => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [options, setOptions] = useState({ size: '' });

  const handleModal = (content = false, modalOptions = { size: 'default' }) => {
    setShowModal(!!content);
    if (content) {
      setModalContent(content);
      setOptions(modalOptions);
    } else setModalContent(null);
  };

  return { showModal, handleModal, modalContent, options };
};
